module.exports = __webpack_public_path__ + "static/media/tashi.5a254a0e.png";